<template>
  <div class="updateSalesman">
    <el-dialog
      title="Salesman Update"
      :modelValue="modelValue"
      width="930px"
      @closed="CloseDialog"
    >
      <div style="display: flex; justify-content: space-between">
        <base-input
          label="Salesman"
          required
          :class="{
            'has-error': validation.isError(validates, 'salesmanCode'),
          }"
        >
          <el-select
            class="select-primary"
            v-model="SalesmanCode"
            placeholder="Salesman"
            filterable
            @change="changeSalesman"
          >
            <el-option
              class="select-primary"
              v-for="item in SalesmanOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </base-input>
        <base-input label="Team Head">
          <el-select
            class="select-primary"
            placeholder="Team Head"
            v-model="TeamHeadCode"
          >
            <el-option
              v-for="(item, index) in TeamHeadOptions"
              :key="'teamhead' + index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </base-input>
        <base-input label="Sale Head" disabled :modelValue="SalesHead">
        </base-input>
        <base-input label="Pool Head" disabled :modelValue="PoolHead">
        </base-input>
      </div>
      <div style="display: flex; justify-content: space-between">
        <base-input
          label="Effective Date"
          required
          style="width: 50%"
          :class="{
            'has-error': validation.isError(validates, 'effectiveDate'),
          }"
        >
          <el-date-picker
            v-model="EffectiveDate"
            type="date"
            value-format="YYYY-MM-DD"
            format="DD/MM/YYYY"
            placeholder="Effective Date"
            class="custom-date-picker"
            style="border: 0px"
            :clearable="false"
            :disabled-date="disableDate"
            popper-class="changeaction-date-picker"
          ></el-date-picker>
        </base-input>
      </div>
      <div style="display: flex; justify-content: space-between">
        <base-input label="Remark" style="width: 100%">
          <el-input
            type="textarea"
            :rows="3"
            v-model="Remark"
            style="border: 0"
          ></el-input>
        </base-input>
      </div>
      <template #footer>
        <base-button type="primary" @click="updateEvent" v-if="!disabled"
          >Save</base-button
        >
        <base-button @click="CloseDialog">Close</base-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import { ref, watch, onMounted } from 'vue';
import { useOrderStore } from '@/store/order';
import booknet from '@/network/booknet';
import validation from '@/assets/js/validation';
import { dayjs, ElMessage } from 'element-plus';
import dayJs from 'dayjs';

const props = defineProps({
  modelValue: {
    type: Boolean,
  },
  disabled: {
    type: Boolean,
    default: false,
    description: '组件状态',
  },
});

const messageConfig = require('@/models/messageConfig');
const OrderSalesRules = {
  salesmanCode: {
    required: true,
    message: messageConfig.getMessage('validformrequire'),
  },
  effectiveDate: {
    required: true,
    message: messageConfig.getMessage('validformrequire'),
  },
};

const emits = defineEmits(['update:modelValue']);

const useOrder = useOrderStore();

var SalesList = [];
var SalesmanOptions = ref([]);
var TeamHeadOptions = ref([]);
// var SalesHeadOptions = ref([]);
// var PoolHeadOptions = ref([]);
var validates = ref([]);
const SalesmanCode = ref();
const Salesman = ref();
const TeamHeadCode = ref();
const TeamHead = ref();
const SalesHeadCode = ref();
const SalesHead = ref();
const PoolHeadCode = ref();
const PoolHead = ref();
const EffectiveDate = ref(null);
const Remark = ref('');

SalesmanCode.value = useOrder.Sales.salesmanCode;
Salesman.value = useOrder.Sales.salesman;
TeamHeadCode.value = useOrder.Sales.teamHeadCode;
TeamHead.value = useOrder.Sales.teamHead;
SalesHeadCode.value = useOrder.Sales.salesHeadCode;
SalesHead.value = useOrder.Sales.salesHead;
PoolHeadCode.value = useOrder.Sales.poolHeadCode;
PoolHead.value = useOrder.Sales.poolHead;

onMounted(() => {
  SalesList = useOrder.getSalesList();

  if (SalesList.length > 0) {
    var sales = SalesList.map((t) => {
      return { value: t.salesmanCode, label: t.salesman };
    });

    SalesmanOptions.value = sales.filter(
      (item, index) => sales.findIndex((i) => i.value == item.value) === index
    );
  }

  getTeamHeadOptions();
});

// 关闭窗口
const CloseDialog = () => {
  emits('update:modelValue', false);
};

// const getTeamHeadOptions = async () => {
//   const option_api = require('@/network/optional').default;

//   const option_res = await option_api
//     .getChangeActionOptionals()
//     .then((res) => res.data);

//   console.log(option_res);
//   TeamHeadOptions.value = option_res.data.teamHeadOptions;
// };
//getTeamHeadOptions();

const getTeamHeadOptions = () => {
  TeamHeadOptions.value = [];

  var sales = SalesList.filter((t) => t.teamHeadCode);

  if (sales.length > 0) {
    var teamHead_options = sales.map((t) => {
      return { value: t.teamHeadCode, label: t.teamHead };
    });

    TeamHeadOptions.value = teamHead_options.filter(
      (item, index) =>
        teamHead_options.findIndex((i) => i.value == item.value) === index
    );
  }
};

const changeSalesman = () => {
  var sales_info = SalesList.find((t) => t.salesmanCode == SalesmanCode.value);
  if (sales_info) {
    TeamHeadCode.value = sales_info?.teamHeadCode;
    TeamHead.value = sales_info?.teamHeadName;
  }
};

const updateEvent = async () => {
  const orderSalesRecord = {
    salesmanCode: SalesmanCode.value,
    salesmanName: Salesman.value,
    teamHeadCode: TeamHeadCode.value,
    teamHeadName:
      TeamHeadOptions.value.find((t) => t.value === TeamHeadCode.value)
        ?.label || '',
    salesHeadCode: SalesHeadCode.value,
    salesHeadName: SalesHead.value,
    poolHeadCode: PoolHeadCode.value,
    poolHeadName: PoolHead.value,
    effectiveDate: EffectiveDate.value,
    remark: Remark.value,
    orderId: useOrder.Order.id,
  };

  validates.value = await validation
    .validate(orderSalesRecord, OrderSalesRules)
    .then((err) => err);

  if (validates.value?.[0]?.message) {
    ElMessage({
      message: validates.value[0].message,
      type: 'warning',
    });
    return;
  }

  //更新订单销售员信息
  const ordersales_res = await booknet
    .changeOrderSalesTeamAndRecord(orderSalesRecord)
    .then((res) => res);
  if (ordersales_res.data !== 'OK') {
    throw ordersales_res.data;
  }

  useOrder.Sales.salesmanCode = SalesmanCode.value;
  useOrder.Sales.salesman = Salesman;
  useOrder.Sales.teamHeadCode = TeamHeadCode.value;
  useOrder.Sales.teamHead = TeamHead.value;
  useOrder.Sales.salesHeadCode = SalesHeadCode.value;
  useOrder.Sales.salesHead = SalesHead.value;
  useOrder.Sales.poolHeadCode = PoolHeadCode.value;
  useOrder.Sales.poolHead = PoolHead.value;
  useOrder.Sales.effectiveDate = EffectiveDate.value;

  useOrder.setEnableChangeHistory(true);

  CloseDialog();
};
// DatePicker 日期禁用
const disableDate = (date) => {
  var now = dayJs().format('YYYY-MM-DD');
  var newdate = dayJs(date).format('YYYY-MM-DD');

  if (useOrder.getUnit()?.alias === 'BB') {
    if (dayJs(newdate).isSame(dayJs(now))) {
      return false;
    }

    return dayJs(newdate).isAfter(dayJs(now));
  }

  return false;
};

// watch
watch(
  () => TeamHeadCode.value,
  (newValue) => {
    TeamHead.value =
      TeamHeadOptions.value.find((t) => t.value === newValue)?.label || '';
  },
  {
    immediate: true,
  }
);

// watch
watch(
  () => SalesmanCode.value,
  (newValue) => {
    Salesman.value =
      SalesList.find((t) => t.salesmanCode === newValue)?.salesman || '';
  },
  {
    immediate: true,
  }
);
</script>

<style>
.changeaction-date-picker .el-date-picker {
  width: 318px !important;
}
.changeaction-date-picker .el-date-picker .el-picker-panel__content {
  width: 310px !important;
}
</style>
